export class DecisionActionValueReader {
  readStringValue(
    values: Record<string, unknown>,
    keys: readonly string[]
  ): string | undefined {
    for (const key of keys) {
      const value = values[key];
      if (typeof value === "string" && value.trim().length > 0) {
        return value;
      }
    }

    return undefined;
  }

  readUnknownValue(
    values: Record<string, unknown>,
    keys: readonly string[]
  ): unknown {
    for (const key of keys) {
      const value = values[key];
      if (value !== undefined) {
        return value;
      }
    }

    return undefined;
  }

  readNumberValue(
    values: Record<string, unknown>,
    keys: readonly string[]
  ): number | undefined {
    for (const key of keys) {
      const value = values[key];
      if (typeof value === "number" && Number.isFinite(value)) {
        return value;
      }
      if (typeof value === "string" && value.trim().length > 0) {
        const parsed = Number(value);
        if (Number.isFinite(parsed)) {
          return parsed;
        }
      }
    }

    return undefined;
  }

  readBooleanValue(
    values: Record<string, unknown>,
    keys: readonly string[]
  ): boolean | undefined {
    for (const key of keys) {
      const value = values[key];
      if (typeof value === "boolean") {
        return value;
      }
      if (typeof value === "string") {
        const normalized = value.trim().toLowerCase();
        if (normalized === "true") {
          return true;
        }
        if (normalized === "false") {
          return false;
        }
      }
    }

    return undefined;
  }

  toPayloadRecord(value: unknown): Record<string, unknown> {
    if (!value || typeof value !== "object" || Array.isArray(value)) {
      return {};
    }

    return { ...(value as Record<string, unknown>) };
  }

  compactPayload(
    payload: Record<string, unknown>
  ): Record<string, unknown> | undefined {
    const compacted = Object.entries(payload).reduce<Record<string, unknown>>(
      (accumulator, [key, value]) => {
        if (value === undefined || value === null || value === "") {
          return accumulator;
        }
        accumulator[key] = value;
        return accumulator;
      },
      {}
    );

    return Object.keys(compacted).length ? compacted : undefined;
  }
}
